module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-times",
      "type": "danger",
      "value": "Prosseguir com o Calcelamento"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54438f93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/configuracao/cancelar.vue
// module id = 1508
// module chunks = 45